import seedrandom from "seedrandom";

export const fisherYatesShuffle = (options = [], random = Math.random) => {
  const shuffled = Array.isArray(options) ? [...options] : [];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [
      shuffled[swapIndex],
      shuffled[index],
    ];
  }

  return shuffled;
};

const buildAnswerOrderSeed = ({ sessionNonce, questionId }) =>
  `${String(sessionNonce || "")}\u0000${String(questionId || "")}`;

export const shuffleAnswersForSession = (
  options = [],
  { sessionNonce, questionId } = {},
) =>
  fisherYatesShuffle(
    options,
    seedrandom(buildAnswerOrderSeed({ sessionNonce, questionId })),
  );
